import { MdOutlineWarning } from 'react-icons/md';
import { CarGroundIcon } from '@icons';

export const GroundNotFeasibleWarning = () => {
  return (
    <div className="w-max flex px-1 py-0.5 rounded-sm gap-1 bg-base-70">
      <div className="text-warning-40">
        <MdOutlineWarning size={16} />
      </div>
      <CarGroundIcon />
      <span className="text-s-r text-base-10">Ground leg is not feasible.</span>
    </div>
  );
};
